import { authHeaders, baseUrl, handleResponse } from './apiUtils';

async function calendarResponse(response) {
  if (response.ok || response.status === 401) return handleResponse(response);
  let body;
  try {
    body = (await response.json()) || {};
  } catch (error) {
    body = {};
  }
  throw Object.assign(new Error(body.error || 'Nie udało się pobrać kalendarza szkoły.'), { statusCode: response.status, code: body.code, field: body.field });
}

async function getCalendar(schoolYearStart, { signal } = {}) {
  return calendarResponse(await fetch(`${baseUrl}school-calendar/${encodeURIComponent(schoolYearStart)}`, { headers: authHeaders(), signal }));
}

async function saveCalendar(schoolYearStart, request) {
  return calendarResponse(await fetch(`${baseUrl}school-calendar/${encodeURIComponent(schoolYearStart)}`, {
    method: 'PUT', headers: { ...authHeaders(), 'Content-Type': 'application/json' }, body: JSON.stringify(request),
  }));
}

export default { getCalendar, saveCalendar };
